// shims
import "./shim/match-media";
// shims

export * from "./editQuiz";
export * from "./types/common";
export * from "./api/fetch";
export * from "./button";
export * from "./downloadButton";
export * from "./modal";
export * from "./switch";
export * from "./theme";
export * from "./hooks";
export * from "./wrapper";
export * from "./screenReader";
export * from "./before-quiz";
export * from "./progressBar";
export * from "./interceptStrategy";
export * from "./support-modal";
export * from "./tooltip";
export * from "./card";
export * from "./setup-guide";
export * from "./institution-settings";
export { default as scrollbarThemeOverrides } from "./core/scrollbar";
export { packageLanguageChanger, resources } from "./i18n/i18n";
export { default as ThemeWrapper } from "./theme";
export {
	default as InstallLockdownPage,
	InstallLockdownModalContent,
	determineLockdownDownloadLinkType,
} from "./lockdownInstall/installLockdown";
export { default as InstallMobilePage, InstallMobileModalContent } from "./mobileInstall/installMobile";
export { getReactNodeText, isMobileDevice } from "./util";
